import Script from 'next/script'

export const GOOGLE_TAG_MANAGER_ID = 'G-0BQX5T7N4T'

export function GoogleTagManager() {
  return (
    <Script
      strategy="afterInteractive"
      src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_MANAGER_ID}`}
    />
  )
}
